import { render } from "./ResumeSectionGrossTonnage.vue?vue&type=template&id=8cdab6da"
import script from "./ResumeSectionGrossTonnage.vue?vue&type=script&lang=js"
export * from "./ResumeSectionGrossTonnage.vue?vue&type=script&lang=js"

import "./ResumeSectionGrossTonnage.vue?vue&type=style&index=0&id=8cdab6da&lang=css"
script.render = render

export default script